import React, { useEffect, useState } from 'react'
import Logoicono from '../Componentes/logosvg2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

function ConfirmarCorreo() {

    axios.defaults.withCredentials = true;
    const [solicitud, setSolicitud] = useState(false);
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const token = params.get("c");

   useEffect(() => {
        if (token) {
            console.log(token)
            axios.get(`${process.env.REACT_APP_HTTPS}/api/estable/confcorreo`, {params: { c: token }})
            .then(response => {
                if (response.data.success === true){
                    setSolicitud(true);
                } else if (response.data.success === false){
                    console.log(response.data.message);
                    setSolicitud(null);
                    toast.error('Por favor contacte al correo.',{position: 'top-center'})
                }
            })
            .catch((response)=> {
                console.error('No existe el token:', response);
                toast.error('Error al confirmar, por favor contacte al correo', {position: 'top-center'});
                return ; 
            });

          } else {
            setSolicitud(null);
          }
    },[])

  return (
    <div className='Camb_contenedor'>
        <div className='Ltitulo'>
        <div className='Llogotitulo'><Logoicono/></div>
        <p onClick={() => navigate('/')} style={{cursor:'pointer', color: 'white', fontSize: '40px', marginTop:'7px'}}>Chamuscón</p></div>
        {solicitud === false ? 
        (<><div className="Camb_cambio">
            <h2>Confirmando...</h2>
        </div></>): 
        
        solicitud === true ? 
        (<>
        <div className="Camb_cambio">
            <h2>Correo confirmado</h2>
            <p>Te notificaremos cuando se apruebe la informacion ingresada</p>
        </div></>)
        :(<><div className="Camb_cambio">
            <h2>Solicitud invalida, contacte al correo</h2>
        </div></>)}
    </div>
  )
}

export default ConfirmarCorreo